import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-clipboard-icon',
  templateUrl: './general-clipboard.component.html'
})
export class GeneralClipboardComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
